import React from 'react';
import PropTypes from 'prop-types';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

import {
    ITEM_CONTAINS,
    ENERGY_KCAL,
    ENERGY_KJ,
    FAT,
    SATURATES,
    CARBS,
    SUGARS,
    FIBRE,
    PROTEIN,
    SALT,
    ABV
} from '../modules/constants';

function Facts({ nutritionalFacts }) {
    const {
        alcoholByVolumePercent,
        energyKcal,
        energyKj,
        fatMg,
        saturatesMg,
        totalCarbsMg,
        sugarsMg,
        fibreMg,
        proteinMg,
        saltMg
    } = nutritionalFacts;

    function grams(val) {
        return val / 1000;
    }

    return (
        <div className='block n'>
            <h4>{ITEM_CONTAINS}</h4>
            <table>
                <tbody>
                    <tr>
                        <th>{ENERGY_KCAL}</th>
                        <th>{energyKcal}</th>
                    </tr>
                    <tr>
                        <td>{ENERGY_KJ}</td>
                        <td>{energyKj}</td>
                    </tr>
                    <tr>
                        <th>{FAT}</th>
                        <th>{grams(fatMg)}</th>
                    </tr>
                    <tr>
                        <td>{SATURATES}</td>
                        <td>{grams(saturatesMg)}</td>
                    </tr>
                    <tr>
                        <th>{CARBS}</th>
                        <th>{grams(totalCarbsMg)}</th>
                    </tr>
                    <tr>
                        <td>{SUGARS}</td>
                        <td>{grams(sugarsMg)}</td>
                    </tr>
                    <tr>
                        <th>{FIBRE}</th>
                        <th>{grams(fibreMg)}</th>
                    </tr>
                    <tr>
                        <th>{PROTEIN}</th>
                        <th>{grams(proteinMg)}</th>
                    </tr>
                    <tr>
                        <th>{SALT}</th>
                        <th>{grams(saltMg)}</th>
                    </tr>
                    {alcoholByVolumePercent ? (
                        <tr>
                            <th>{ABV}</th>
                            <th>{alcoholByVolumePercent}</th>
                        </tr>
                    ) : null}
                </tbody>
            </table>
        </div>
    );
}

Facts.propTypes = {
    nutritionalFacts: PropTypes.object
};

/**
 * Component to display nutritional information returned by the API for an item.
 *
 * @function
 * @param       {object} nutritionalFacts nutritionFacts object from the API
 * @constructor
 */
function NutritionFacts({ nutritionalInfo }) {
    const nutritionalFacts = nutritionalInfo.factsForPortionSizes;

    if (!nutritionalFacts || !nutritionalFacts.length) {
        return null;
    }

    if (nutritionalFacts.length === 2) {
        return (
            <Tabs className='tabs additional'>
                <TabList className='tablist'>
                    <Tab>Regular</Tab>
                    <Tab>Large</Tab>
                </TabList>
                <TabPanel className='tabpanel'>
                    <Facts nutritionalFacts={nutritionalFacts[0]} />
                </TabPanel>
                <TabPanel className='tabpanel'>
                    <Facts nutritionalFacts={nutritionalFacts[1]} />
                </TabPanel>
            </Tabs>
        );
    }

    return <Facts nutritionalFacts={nutritionalFacts[0]} />;
}

NutritionFacts.propTypes = {
    nutritionalInfo: PropTypes.object
};

export { NutritionFacts };
